import React from "react"
import { Collapse, Row } from "reactstrap"
import classnames from "classnames"
import MobileTableBody from "./mobileTableBody"
import moment from "moment"

const MobileView = ({
  sethandleAccordion,
  handleAccordion,
  keyId,
  user_name,
  data,
  averageData,
  supervisorFilter,
  activeReportStatus,
  handleOnExpand,
  handleVerify,
}) => {
  const handleOnclickAccordion = value => {
    if (handleAccordion === value) {
      sethandleAccordion(null)
    } else {
      sethandleAccordion(value)
    }
  }
  return (
    <React.Fragment>
      <Row>
        <div className="accordion" id="accordion" key={keyId}>
          <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingOne">
              <button
                className={classnames(
                  "accordion-button zIndexes zIndexesNo",
                  "fw-medium",
                  {
                    collapsed: handleAccordion !== keyId,
                  }
                )}
                type="button"
                onClick={() => handleOnclickAccordion(keyId)}
                style={{ cursor: "pointer" }}
              >
                {user_name}
              </button>
            </h2>
            <Collapse
              isOpen={handleAccordion === keyId}
              className="accordion-collapse"
            >
              <div className="accordion-body">
                <div className="text-muted">
                  <div className="text-center d-block mb-2 text-uppercase font-weight-bold">
                    OverAll Summary
                  </div>
                  <Row>
                    <table className="table table-striped">
                      <tbody>
                        <MobileTableBody
                          item={averageData}
                          supervisorFilter={supervisorFilter}
                          activeReportStatus={activeReportStatus}
                          hidecolumn={false}
                          handleOnExpand={handleOnExpand}
                          handleVerify={handleVerify}
                        />
                      </tbody>
                    </table>
                  </Row>
                  {data.map((item, index) => (
                    <table className="table table-striped" key={index}>
                      <div className="text-end d-block mb-2 text-uppercase font-weight-bold">
                        {supervisorFilter.id === 4 ||
                        activeReportStatus.id === 2
                          ? "Team Members"
                          : `Summary (${moment(item.date).format(
                              "YYYY-MM-DD"
                            )})`}
                      </div>

                      <tbody>
                        <MobileTableBody
                          item={item}
                          supervisorFilter={supervisorFilter}
                          activeReportStatus={activeReportStatus}
                          hidecolumn={true}
                          handleOnExpand={handleOnExpand}
                          handleVerify={handleVerify}
                        />
                      </tbody>
                    </table>
                  ))}
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </Row>
    </React.Fragment>
  )
}

export default MobileView
